import React, { useState } from 'react';
import Modal from '@hubins/components/Modal';
import Button from '@hubins/components/Button';
import __ from 'localisation';
import { useTaxDomicileHistory } from 'queries/taxDomiciles';
import { LoadingBox } from '@hubins/components/LoadingIndicators';
import SimpleTable from 'modules/Tables/SimpleTable';

const tableHeaders = [
  {
    Header: __('date'),
    accessor: 'date',
  },
  {
    Header: __('updated_by'),
    accessor: 'updated_by',
  },
  {
    Header: __('event'),
    accessor: 'event',
  },
  {
    Header: __('attributes'),
    accessor: 'attributes',
    Cell: ({ value }) => {
      return (
        <pre>
          {JSON.stringify(value, null, 2)}
        </pre>
      );
    },
  },
];

const TaxDomicileHistory = ({ profileUuid }) => {
  const [open, setOpen] = useState(false);
  const { data, isLoading, isFetched } = useTaxDomicileHistory(profileUuid, open);

  return (
    <>
      <Button className='cta' iconColor='white' icon="Common File Text by Streamlinehq" onClick={() => setOpen(true)}>
        {__('history')}
      </Button>
      <Modal open={open} callback={setOpen} closeButton={true} shouldCloseOnOverlayClick={true}>
        {(isLoading || !isFetched) ? (
          <LoadingBox />
        ) : (
          <div className='s-top-l'>
            <SimpleTable headers={tableHeaders} data={data || []} />
          </div>
        )}
      </Modal>
    </>
  );
};

export default TaxDomicileHistory;